

const updateFormValuePinnedData = () => {
   const pinnedJobsContactFormSections = [...document.querySelectorAll('[data-contact-form-hidden-inputs]')];
   let pinnedJobs = JSON.parse(localStorage.getItem('pinnedJobs')) || [];
   let pinnedJobNames = JSON.parse(localStorage.getItem('pinnedJobNames')) || [];
   const newPinnedJobCount = pinnedJobs.length;
   let newPinnedJobNames = '';
   if (pinnedJobNames.length > 0) {
      newPinnedJobNames = '[';
      pinnedJobNames.forEach(name => {
         if (newPinnedJobNames === '[') {
            newPinnedJobNames += `${name}]`;
         } else {
            newPinnedJobNames += ` [${name}]`;
         }
      });
   } else {
      newPinnedJobNames = 'No Pinned Jobs';
   }
   pinnedJobsContactFormSections.forEach(form => {
      form.querySelector('.pinned-job-count').value = newPinnedJobCount;
      form.querySelector('.pinned-jobs').value = newPinnedJobNames;
   });
};

export default updateFormValuePinnedData;